import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import '../../styles/chapter2/fast-video.scss';

import img from '../../poster/video-fast.jpg';

class FastVideo extends React.Component{


	constructor(props){

		super(props);

		this.state = {
			canplaythrough : true,
			showHoldMessage : false,
			wasTriggered : false,
			shouldBeVisible : true,
			percentage : 0,
		}
		
		//__________________________
		this.fps = 15;
		this.now;
		this.then = Date.now();
		this.interval = 1000/this.fps;
		this.delta;
		this.backwardsSpeed = .25;
		this.loop = null;
		//__________________________

		this.playVideoForward = true;
		this.videoTime = 0;

	}


	componentDidMount(){

		this.addHandler();
		this.update();

		setTimeout(()=>{
			this.setState({
				showHoldMessage : true
			});
		},1000);
	}


	componentWillUnmount(){
		this.video.pause();
		this.video.removeEventListener('canplaythrough',this.canplaythroughAction);
		this.video.removeEventListener('loadedmetadata', this.loadedmetadata);
		this.video.removeEventListener('waiting', this.isWaitingAction);
		this.video.removeEventListener('timeupdate', this.timeupdate);

		cancelAnimationFrame(this.loop);

		window.removeEventListener('keydown', this.keydown);
		window.removeEventListener('keyup', this.keyup);
		window.removeEventListener('touchstart', this.touchstart);
		window.removeEventListener('touchend', this.touchend);
	}

	videoPlay(){
		this.setState({
			wasTriggered : true
		});
		if(this.video.paused && !this.videoShouldPlay){
      this.video.play();
      this.playVideoForward = true;
    }
    this.videoShouldPlay = true;
	}

	videoBackwards(){
		//console.log('videoBackwards');
	  this.videoShouldPlay = false;
		if(!this.video.paused){
		  this.video.pause();
		  this.playVideoForward = false;
		}
	}


	addHandler(){
		var that  = this;

		this.timeupdate = ()=>{
		  	var percentage = this.video.currentTime * 100 / this.video.duration;
		  	if(percentage > 95){
		  		this.setState({
		  			shouldBeVisible : false
		  		});
		  	}else{
		  		this.setState({
		  			shouldBeVisible : true
		  		});
		  	}
		  	if(percentage >= 100){
		  		this.props.changeInnerChapter(2);
		  		//console.log('ende');
		  	}else{
		  		that.videoTime = this.video.currentTime;
			  }

		}//end of timeupdate

		//define listener
		this.loadedmetadata = () => {		  
		  this.video.addEventListener('timeupdate',this.timeupdate,false);

		  this.canplaythroughAction = ()=>{
		  	this.props.isNotWaiting();
		  	this.setState({
		  		canplaythrough : true
		  	});
		  }
		  this.video.addEventListener('canplaythrough',this.canplaythroughAction,false);

		  this.isWaitingAction = () => {
		  	this.setState({
		  		canplaythrough : false
		  	})
		  	this.props.isWaiting();
		  }
		  this.video.addEventListener('waiting',this.isWaitingAction,false);
		}

		//add listener
		this.video.addEventListener('loadedmetadata',this.loadedmetadata,false);


		this.keydown = (event)=>{

			if(event.target.blur != "undefined"){
				event.target.blur();
			}
			event.preventDefault();
		  event.stopPropagation();

		  if(event.keyCode == 32 && this.state.canplaythrough){

		    this.videoPlay();
		  }
		}

		this.keyup = (event) =>{
			this.videoBackwards();
		}

		this.touchstart = (event)=>{
		  event.preventDefault();
		  event.stopPropagation();
		  if(this.state.canplaythrough){
		  	this.videoPlay();
		  }
		}

		this.touchend = (event)=>{
		  event.preventDefault();
		  event.stopPropagation();
		  this.videoBackwards();
		}


		window.addEventListener('keydown',this.keydown);
		window.addEventListener('keyup',this.keyup);

		window.addEventListener('touchstart',this.touchstart);
		window.addEventListener('touchend',this.touchend);

	}


//________________________________


	update(){
	  this.loop = requestAnimationFrame(()=>this.update());
	  this.now = Date.now();
	    this.delta = this.now - this.then;
	    if (this.delta > this.interval) {    
	        this.then = this.now - (this.delta % this.interval);
	        if(this.state.showHoldMessage){
	        	this.draw();
	        }
	    }
	}

	draw(){
		if(!this.playVideoForward){
			if(this.videoTime > 0){
	      this.videoTime-= this.backwardsSpeed;
	    }
	    if(this.videoTime == 0){
	    	this.playVideoForward = true;
	    }
	    this.video.currentTime = this.videoTime;
	  }

	  var percentage = this.video.currentTime * 100 / this.video.duration;
	  this.progressBar.style.width = percentage + '%';

	  this.props.updateVideoTime(Math.round( percentage) );

	  this.setState({
	  	percentage : percentage
	  });
	  
	}


	render(){

		return (<div className="fast-video">
			<ReactCSSTransitionGroup
				component= "div"
				className="fast-video-progress-holder"
			  transitionName="fade"
			  transitionEnterTimeout={500}
			  transitionLeaveTimeout={300}>
				  {this.state.showHoldMessage && 
				  	<div className={"fast-video-progress wasTriggered-" + this.state.wasTriggered +" should-be-visible-" + this.state.shouldBeVisible}>
							<ReactCSSTransitionGroup
								component= "div"
								className="fast-video-progress-message-holder"
							  transitionName="fade"
							  transitionEnterTimeout={500}
							  transitionLeaveTimeout={300}>
									{this.state.percentage < 5 && _assets.isMobile && 
										<span key={"message"} className="fast-video-progress-message">taphold the screen</span>
									}{this.state.percentage < 5 && !_assets.isMobile &&
										<span key={"message"} className="fast-video-progress-message">hold space</span>
									}
								</ReactCSSTransitionGroup>
							
							{this.state.wasTriggered && 
								<span key={"year-1"} className="fast-video-progress-year-left">2013</span>}
							{this.state.wasTriggered && 
								<span key={"year-2"} className="fast-video-progress-year-right">2017</span>
							}

							<div className="fast-video-progress-inner" ref={(progress)=>{ this.progressBar = progress; }}></div>
						</div>
					}
			</ReactCSSTransitionGroup>

			<div className="videoDOM">
				<video className="" preload="auto" poster={img} playsInline ref={(video)=>{this.video = video;}}>
					<source ref={(src)=>{this.source = src;}} src={_assets.root + "/video/chapter2/intro_space.mp4"} type="video/mp4" />
				</video>
			</div>
		</div>);
	}
}

export default FastVideo;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/chapter_two_fast_video.js